'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDescription = function (_Component) {
  (0, _inherits3.default)(EventDescription, _Component);

  function EventDescription() {
    (0, _classCallCheck3.default)(this, EventDescription);
    return (0, _possibleConstructorReturn3.default)(this, (EventDescription.__proto__ || (0, _getPrototypeOf2.default)(EventDescription)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventDescription, [{
    key: 'render',
    value: function render() {
      if (this.props.description) {
        return _react2.default.createElement('div', { className: 'EventDescription', dangerouslySetInnerHTML: { __html: this.props.description } });
      }
      return null;
    }
  }]);
  return EventDescription;
}(_react.Component);

EventDescription.propTypes = {
  /**
   * The HTML description.
   */
  description: _propTypes2.default.string
};
exports.default = EventDescription;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDescription.js
// module id = 267
// module chunks = 0